<template>
  <div class="msg" ref="msg" v-if="isShow">
     <!-- <el-dialog title="告警通知" :visible.sync="isShow1" width="32%" height="80vh" append-to-body @close="closeAlarm" custom-class="dialog-right-top"> -->
         <!-- 主要告警列表 -->
           <!-- 标题栏 -->
        <div class="title-bar top" @click="showDetail()">
          <div class="dflex">
             <img src="../assets/imgs/warning.png" />
             <span class="title">紧急告警通知</span>
          </div>
          <i class="el-icon-circle-close" @click="closeAlarm" style="margin-right:12px;"></i>
        </div>
      <div v-for="(alarm, index) in allType" :key="index" class="alarm-item">
        <!-- 核心告警区 -->
        <div class="core-alert">
          <strong>[{{alarm. deviceType}}]</strong> {{ alarm.title }}
        </div>

        <!-- 关键信息区 -->
        <div class="info-section">
          <p>• 设备：{{ alarm.equipmentName }} (SN: {{ alarm.equipmentNumber }})</p>
          <p>• 对象：{{ alarm.customerName }} (ID: {{ alarm.customerId }})</p>
          <p>• 时间：{{ alarm.alarmTimeStr }}</p>
        </div>

        <!-- 详情内容区 -->
        <div class="detail-content">{{ alarm.content }}</div>

        <!-- 操作按钮区 -->
        <div class="action-buttons">
          <!-- <el-button size="small" @click="markAsHandled(index)">标记为已处理</el-button> -->
          <el-button type="primary" size="small" @click="showDetail(alarm)">查看详情</el-button>
        </div>
        <audio id="audio" src="../assets/imgs/audio.ogg" ref="audio" loop controls muted autoplay style="height: 0px"
          v-if="Isaudio"></audio>
      </div>
     <!-- </el-dialog> -->
  </div>
</template>

<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import axios from "axios"
import exportVue from "@/utils/exportVue"
import { volunteerArchiveApi } from "../api/http"
export default {
  name: "msg",
  mounted() { },
  data() {
    return {
      info: {},
      infos: {},
      List: [{ id: 1, name: "2" }],
      rights: 40,
      bottoms: 30,
      wy: "",
      alldata: {},
      infoIndex: 0,
      Isaudio: false,
      connectError: false,
      allType: [],
      isShow:false,
      socket: null,
      lockReconnect: false,
      timeout: 30 * 1000, //30s一次心跳
      timeoutObj: null, //心跳倒计时
      serverTimeoutObj: null, //心跳心跳倒计时
      timeoutnum: null, //断开
    }
  },
  props: ["dialogVisible"],
  created() {
    //this.getTime()
    exportVue.$on("istrue", (data) => {
      if (data == true) {
        this.time = setTimeout(() => {
          this.common()
        }, 50000)
      } else {
        clearTimeout(this.time)
      }
    })
    this.getwebsocket()
  },
  beforeDestory() {
    this.socket.close()
    //清除时间
    clearTimeout(this.timeoutObj)
    clearTimeout(this.serverTimeoutObj)
  },
  methods: {
    getwebsocket() {
      // var wsUrl =
      //   "ws://" +
      //   baseURL.replace("http://", "").replace("/api", "").split(":")[0] +
      //   ":10004/websocket"
      var wsUrl = "ws://101.37.30.244:3336/alarm/websocket"
      this.socket = new WebSocket(wsUrl)
      this.socket.onerror = (event) => {
        console.log("websocket服务出错了")
        //this.reconnect(wsUrl)
      }
      this.socket.onclose = (event) => {
        console.log("websocket服务关闭了")
        //this.reconnect(wsUrl)
      }
      this.socket.onopen = (event) => {
        console.log(this.socket, "连接成功")
        this.start() //开启心跳
      }
      this.socket.onmessage = (event) => {
        //如果获取到消息，心跳检测重置
        //拿到任何消息都说明当前连接是正常的
        //console.log('websocket服务获得数据了');
        //接受消息后的UI变化
        console.log(JSON.parse(event.data), "接收消息")
        console.log(JSON.parse(event.data), this.$store.state.info.dataId, '--')
        if (JSON.parse(event.data).dataId == this.$store.state.info.dataId) {
          this.infos = JSON.parse(event.data)
          this.allType.push(this.infos)
          if (this.allType.length == 1) {
            console.log("是否再次点击")
            this.Isaudio = true
            this.info = this.allType[this.allType.length - 1]
            this.info.type = String(this.info.type)
            this.$emit("close", true)
          }
          this.isShow=true
          console.log(this.allType,'this.allType')
        }
        
        this.reset() //收到服务器信息 心跳重置
      }
    },
    closeAlarm(){
      this.isShow=false
      this.$emit('close',false)
    },
    showDetail(row){
         this.$router.push({
           name: "deviceInfo",
           params: { customerName: row.customerName },  //row.id
        })
    },
    reconnect(url) {
      var that = this
      if (that.lockReconnect) {
        return
      }
      that.lockReconnect = true
      //没连接上会一直重连 设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum)
      that.timeoutnum = setTimeout(function () {
        that.getwebsocket() //新连接
        that.lockReconnect = false
      }, 5000)
    },
    reset() {
      //重置心跳
      var that = this
      clearTimeout(that.timeoutObj)
      clearTimeout(that.serverTimeoutObj)
      that.start() //重启心跳
    },
    //心跳检测
    start() {
      var self = this
      self.timeoutObj && clearTimeout(self.timeoutObj)
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj)
      self.timeoutObj = setTimeout(function () {
        console.log(self.socket, "开始测试心挑")
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        //onmessage拿到返回的心跳就说明连接正常
        if(self.socket.WebSocket){
           self.socket.WebSocket.send("心跳测试")
        }
        //如果超过一定时间还没重置，说明后端主动断开了
        self.serverTimeoutObj = setTimeout(function () {
          //如果onclose会执行reconnect，我们执行ws.close()就行了.
          //如果直接执行reconnect 会触发onclose导致重连两次
          self.socket.close()
        }, self.timeout)
      }, self.timeout)
    },
    callPhone(phone) {
      if (phone) {
        this.$router.push({
          name: "customerInfo",
          params: { phone: phone },
        })
      }
    },
    callPhone1(phone) {
      if (phone) {
        this.$router.push({
          name: "customerInfo",
          params: { phone: phone },
        })
      }
    },
    callPhone2(phone) {
      if (phone) {
        this.$router.push({
          name: "customerInfo",
          params: { phone: phone },
        })
      }
    },
    save() {
      axios({
        method: "post",
        url: baseURL + "/ypt/admin/warningInfo/info/saveWarningInfo",
        data: {
          remarks: this.info.remarks,
          disposalStatus: 1,
          msgKey: this.info.msgKey,
        },
      })
        .then((res) => {
          if (res.data.code == 200) {
            this.$emit("close", false)
            clearTimeout(this.time)
            this.Isaudio = false
            this.allType.forEach((item, index) => {
              if (item.msgKey == this.info.msgKey) {
                this.allType.splice(index, 1)
              }
            })
            if (this.allType.length > 0) {
              this.$emit("close", true)
              this.Isaudio = true
              this.info = this.allType[this.allType.length - 1]
              this.info.type = String(this.info.type)
            }
          }
        })
        .catch((error) => {
          this.$message.error(res.data.mesage)
          this.$emit("close", false)
          this.Isaudio = false
          clearTimeout(this.time)
        })
    },
    close() {
      this.common()
    },
    common() {
      this.$emit("close", false)
      this.Isaudio = false
      this.allType.forEach((item, index) => {
        if (item.msgKey == this.info.msgKey) {
          this.allType.splice(index, 1)
        }
      })
      if (this.allType.length > 0) {
        this.$emit("close", true)
        this.Isaudio = true
        this.info = this.allType[this.allType.length - 1]
        this.info.type = String(this.info.type)
      } else {
        this.$emit("close", false)
        this.Isaudio = false
        clearTimeout(this.time)
      }
      //  `console.log(this.allType.length, "this.allType.length")
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.el-input {
  width: 100%;
}
.alarm-item {
  border-radius: 4px;
  padding: 16px 16px 0;
  background: #fff;
}

.title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  color: #303133;
  // margin-bottom: 12px;
  font-size:14px;
  margin-top:5px;
  .dflex{
    display: flex;
     align-items: center;
  }
  img{
    width:20px;
    height:20px;
  }
}

.icon {
  color: #409eff;
}

.close-icon {
  cursor: pointer;
  color: #909399;
}

.core-alert {
  font-size: 12px;
  font-weight: bold;
  color: #f56c6c;
  margin-bottom: 12px;
}

.info-section {
  margin-bottom: 12px;
  line-height: 1.2;
  color: #606266;
  font-size:12px;
}

.detail-content {
  margin-bottom: 16px;
  line-height: 1.6;
  color: #606266;
}

.action-buttons {
  display: flex;
  gap: 10px;
  margin-left:25px;
}
.msg {
  position: fixed;
  z-index: 9999;
  overflow-y: auto;
  height: 200px;
  width:250px;
  border: 1px solid #b5b5b5;
  background:#fff;
  padding-bottom:16px;

  .top {
    width: 100%;
    text-align: center;

    p {
      color: #fff;
    }

  }

  .forms {
    padding: 20px 20px;
    background: #f5f5f5;

    .el-icon-phone {
      margin-left: 14px;
      cursor: pointer;
    }
  }
}

/deep/.el-input__inner {
  background-color: #f5f5f5;
}

/deep/.el-textarea__inner {
  background-color: #f5f5f5;
  color: #000000;
  font-weight: bold;
  font-size: 18px;
}

.dialog-footer {
  text-align: center;
}

/deep/.el-button--primary {
  background-color: #3f5292;
  margin-left: 8px;
}

/deep/.el-button--default {
  background: #9fa8c5;
  color: #fff;
}

/deep/.el-button {
  padding: 4px 10px;
}

/deep/.el-input.is-disabled .el-input__inner {
  color: #000000;
  font-weight: bold;
  font-size: 18px;
}

/deep/.el-textarea.is-disabled .el-textarea__inner {
  color: #000000;
  font-weight: bold;
  font-size: 18px;
}

/deep/.el-form-item__label {
  color: #000000;
}
</style>
